import React from "react";
import classNames from "classnames";
import Toggle from "../sidebar/Toggle";
import User from "./dropdown/user/User";
import ChatDropdown from "./dropdown/chat/Chat";
import { Link } from "react-router-dom";
import Logo from "../../images/logo12.png";
import LogoDark from "../../images/logo12.png";

const Header = ({ fixed, theme, className, sidebarToggle, setVisibility }) => {
  const headerClass = classNames({
    "nk-header": true,
    "nk-header-fixed": fixed,
    [`is-light`]: theme === "white",
    [`is-${theme}`]: theme !== "white" && theme !== "light",
    [`${className}`]: className,
  });
  let currentUrl;
  const user = JSON.parse(sessionStorage.getItem('user'))

  if (window.location.pathname !== undefined) {
    currentUrl = window.location.pathname;
  } else {
    currentUrl = null;
  }
  return (
    <div className={headerClass}>
      <div className="container-fluid">
        <div className="nk-header-wrap">
          <div className="nk-menu-trigger d-xl-none ml-n1">
            <Toggle className="nk-nav-toggle nk-quick-nav-icon" icon="menu" click={sidebarToggle} />
          </div>
          <div className="nk-header-app-name">
            <div className="nk-header-app-logo">
              {/* <Icon name="dashlite" className="bg-purple-dim"></Icon> */}
              <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
              <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
              <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
            </Link>
            </div>
            {/* <div className="nk-header-app-info">
              <span className="sub-text">DashLite</span>
              <span className="lead-text">Dashboard</span>
            </div> */}
          </div>
          <div className="nk-header-menu is-light">
            <div className="nk-header-menu-inner">
              {user.code === 44 &&
              <ul className="nk-menu nk-menu-main">
                <li
                  className={`nk-menu-item ${currentUrl === process.env.PUBLIC_URL + "/" ? "active current-page" : ""}`}
                >
                  <Link to={`${process.env.PUBLIC_URL}/`} className="nk-menu-link">
                    <span className="nk-menu-text">Home</span>
                  </Link>
                </li>
                <li
                  className={`nk-menu-item ${
                    currentUrl === process.env.PUBLIC_URL + "/vendor-list" ? "active current-page" : ""
                  }`}
                >
                  <Link to={`${process.env.PUBLIC_URL}/vendor-list`} className="nk-menu-link">
                    <span className="nk-menu-text">Vendors</span>
                  </Link>
                </li>
                <li
                  className={`nk-menu-item ${
                    currentUrl === process.env.PUBLIC_URL + "/agent-list" ? "active current-page" : ""
                  }`}
                >
                  <Link to={`${process.env.PUBLIC_URL}/agent-list`} className="nk-menu-link">
                    <span className="nk-menu-text">Agents</span>
                  </Link>
                </li>
                <li
                  className={`nk-menu-item ${
                    currentUrl === process.env.PUBLIC_URL + "/user-list" ? "active current-page" : ""
                  }`}
                >
                  <Link to={`${process.env.PUBLIC_URL}/user-list`} className="nk-menu-link">
                    <span className="nk-menu-text">Customers</span>
                  </Link>
                </li>
              </ul>}
            </div>
          </div>
          <div className="nk-header-tools">
            <ul className="nk-quick-nav">
              <li className="chats-dropdown hide-mb-xs" onClick={() => setVisibility(false)}>
                <ChatDropdown />
                
              </li>
              {/* <li className="notification-dropdown mr-n1" onClick={() => setVisibility(false)}>
                <Notification />
              </li>
              <li className="list-apps-dropdown d-lg-none" onClick={() => setVisibility(false)}>
                <AppDropdown />
              </li> */}
              <li className="user-dropdown" onClick={() => setVisibility(false)}> 
                <User />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Header;
